import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { UrlService } from "../../core/services/UrlService";
import "./footer.scss"

export const FooterLogo = () => {
    return (
        <div>
            <img className="logo" src={UrlService.getImageUrl('logo-white.png')} srcSet={`${UrlService.getImageUrl('logo-white.png')} 1x, ${UrlService.getImageUrl('logo-white@2x.png')} 2x, ${UrlService.getImageUrl('logo-white@3x.png')} 3x`} alt="" />
            <p className="footer__slogan">
                {/* { t('footer.slogan') } */}
                隨時隨地約見您的醫生
            </p>
        </div>
    );
};

const Footer = () => {
    const localeUrlPrefix = "";
    const socialMediaSprite = UrlService.getImageUrl('social-medias/sprite-white.svg');

    return (
        <footer>
            <div className="footer-container footer-container--desktop container">
                <div className="row flex-column flex-lg-row">
                    <div className="col px-4 pb-4 pb-lg-0">
                        <div className="h5">專科醫生搜尋</div>
                        <ul className="list-unstyled">
                            <li><a className="et-nav-popular" data-specialty-id="53" href="/doctors/%E6%99%AE%E9%80%9A%E7%A7%91%E9%86%AB%E7%94%9F">普通科醫生</a></li>
                            <li><a className="et-nav-popular" data-specialty-id="33" href="/doctors/%E5%A9%A6%E7%94%A2%E7%A7%91%E9%86%AB%E7%94%9F">婦產科醫生</a></li>
                            <li><a className="et-nav-popular" data-specialty-id="12" href="/doctors/%E7%9A%AE%E8%86%9A%E5%8F%8A%E6%80%A7%E7%97%85%E7%A7%91%E9%86%AB%E7%94%9F">皮膚及性病科醫生</a></li>
                            <li><a className="et-nav-popular" data-specialty-id="54" href="/doctors/%E7%89%99%E9%86%AB">牙醫</a></li>
                            <li><a className="et-nav-popular" data-specialty-id="37" href="/doctors/%E8%80%B3%E9%BC%BB%E5%96%89%E7%A7%91%E9%86%AB%E7%94%9F">耳鼻喉科醫生</a></li>
                            <li><a className="et-nav-popular" data-specialty-id="35" href="/doctors/%E7%9C%BC%E7%A7%91%E9%86%AB%E7%94%9F">眼科醫生</a></li>
                            <li><a className="et-nav-popular" data-specialty-id="56" href="/doctors/%E4%B8%AD%E9%86%AB%E5%B8%AB">中醫師</a></li>
                            <li><a href="/specialties">所有專科醫生</a></li>
                        </ul>
                    </div>
                    <div className="col px-4 pb-4 pb-lg-0">
                        <div className="h5">地區醫生搜尋</div>
                        <ul className="list-unstyled">
                            <li><a className="et-nav-popular" data-district-id="7" href="/doctors/%E4%B8%AD%E7%92%B0">中環醫生</a></li>
                            <li><a className="et-nav-popular" data-district-id="32" href="/doctors/%E5%B0%96%E6%B2%99%E5%92%80">尖沙咀醫生</a></li>
                            <li><a className="et-nav-popular" data-district-id="30" href="/doctors/%E6%97%BA%E8%A7%92">旺角醫生</a></li>
                            <li><a className="et-nav-popular" data-district-id="12" href="/doctors/%E9%8A%85%E9%91%BC%E7%81%A3">銅鑼灣醫生</a></li>
                            <li><a className="et-nav-popular" data-district-id="29" href="/doctors/%E4%BD%90%E6%95%A6">佐敦醫生</a></li>
                            <li><a className="et-nav-popular" data-district-id="73" href="/doctors/%E5%B1%AF%E9%96%80">屯門醫生</a></li>
                            <li><a className="et-nav-popular" data-district-id="59" href="/doctors/%E8%8D%83%E7%81%A3">荃灣醫生</a></li>
                            <li><a href="/districts">所有地區醫生</a></li>
                            <li><a href="https://www.finddoc.com.tw" target="_blank" rel="noopener">FindDoc 台灣</a></li>
                            <li><a href="https://www.finddoc.com.sg" target="_blank" rel="noopener">FindDoc 新加坡</a></li>
                        </ul>
                    </div>
                    <div className="col px-4 pb-4 pb-lg-0">
                        <div className="h5">香港醫生集中地</div>
                        <ul className="list-unstyled">
                            <li><a className="et-nav-popular" data-building-id="62" href="/buildings/旺角中心1期-62">旺角中心1期醫生</a></li>
                            <li><a className="et-nav-popular" data-building-id="75" href="/buildings/亞太中心-75">亞太中心醫生</a></li>
                            <li><a className="et-nav-popular" data-building-id="6" href="/buildings/養和醫院-6">養和醫院醫生</a></li>
                            <li><a className="et-nav-popular" data-building-id="48" href="/buildings/中建大廈-48">中建大廈醫生</a></li>
                            <li><a className="et-nav-popular" data-building-id="1" href="/buildings/嘉賓商業大廈-1">嘉賓商業大廈醫生</a></li>
                            <li><a className="et-nav-popular" data-building-id="8" href="/buildings/萬邦行-8">萬邦行醫生</a></li>
                            <li><a className="et-nav-popular" data-building-id="332" href="/buildings/海洋中心-332">海洋中心醫生</a></li>
                            <li><a href="/buildings">所有醫生集中地</a></li>
                        </ul>
                    </div>
                    <div className="col px-4 pb-4 pb-lg-0">
                        <div className="h5">熱門醫院</div>
                        <ul className="list-unstyled">
                            <li><a className="et-nav-popular" data-hospital-id="16" href="/hospital-affiliations/嘉諾撒醫院-16">嘉諾撒醫院</a></li>
                            <li><a className="et-nav-popular" data-hospital-id="20" href="/hospital-affiliations/養和醫院-20">養和醫院</a></li>
                            <li><a className="et-nav-popular" data-hospital-id="23" href="/hospital-affiliations/香港浸信會醫院-23">香港浸信會醫院</a></li>
                            <li><a className="et-nav-popular" data-hospital-id="40" href="/hospital-affiliations/明德國際醫院-40">明德國際醫院</a></li>
                            <li><a className="et-nav-popular" data-hospital-id="60" href="/hospital-affiliations/聖保祿醫院-60">聖保祿醫院</a></li>
                            <li><a className="et-nav-popular" data-hospital-id="61" href="/hospital-affiliations/聖德肋撒醫院-61">聖德肋撒醫院</a></li>
                            <li><a className="et-nav-popular" data-hospital-id="70" href="/hospital-affiliations/仁安醫院-70">仁安醫院</a></li>
                            <li><a className="et-nav-popular" data-hospital-id="25" href="/hospital-affiliations/香港港安醫院-司徒拔道-25">香港港安醫院 - 司徒拔道</a></li>
                            <li><a href="/hospital-affiliations">所有醫院</a></li>
                        </ul>
                    </div>
                    <div className="col px-4 pb-4 pb-lg-0">
                        <div className="h5">FindDoc</div>
                            <ul className="list-unstyled">
                                <li><a href="/about">關於我們</a></li>
                                <li><a href="/contact">聯絡我們</a></li>
                                <li><a href="/careers">加入 FindDoc</a></li>
                                <li><a href="https://www.finddoc.com/health/finddoctv/">FindDocTV</a></li>
                                <li><a href="https://www.finddoc.com/health/guides/">健康指南</a></li>
                                <li><a href="https://www.finddoc.com/health/doctors-blog/">醫生話你知</a></li>
                                <li><a href="https://www.finddoc.com/health/news/提供流感快速測試的診所名單/">提供流感快速測試的診所名單</a></li>
                                <li><a href="/emergency-services">緊急醫療服務</a></li>
                                <li><a href="/privacy">私隱政策</a></li>
                                <li><a href="/terms">使用條款</a></li>
                                <li><a href="/sitemap">網站地圖</a></li>
                            </ul>
                        <hr/>
                        </div>
                    </div>
                    <div className="row flex-column flex-lg-row footer__bottom">
                        <div className="footer__copy">
                            <FooterLogo />
                            <p className="footer__copyright pt-0">
                                <span>
                                    {/* { t('footer.copyright.1')} */}
                                FindDoc 不會提供任何形式的醫療建議、診斷或診治。
                            </span>
                                <span>
                                    版權所有 © 2021 FindDoc
                            </span>
                            </p>
                        </div>
                        <div className="footer__follow-us">
                            <div className="h5">
                                {/* { t('footer.followUs.title') } */}
                            關注我們
                        </div>
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <a href="https://www.facebook.com/FindDoc" target="_blank" rel="noreferrer">
                                        <img src={`${socialMediaSprite}#facebook`} alt="Facebook" />
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://www.youtube.com/user/AskDocTV?sub_confirmation=1" target="_blank" rel="noreferrer">
                                        <img src={`${socialMediaSprite}#youtube`} alt="YouTube" />
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://www.linkedin.com/company/finddoc" target="_blank" rel="noreferrer">
                                        <img src={`${socialMediaSprite}#linkedin`} alt="LinkedIn" />
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://instagram.com/finddochk" target="_blank" rel="noreferrer">
                                        <img src={`${socialMediaSprite}#instagram`} alt="Instagram" />
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://s7.addthis.com/static/wechat_follow.html?id=FindDoc&u=http://weixin.qq.com/r/xiqLk7fEVeoqrfPw93-U" target="_blank" rel="noreferrer">
                                        <img src={`${socialMediaSprite}#wechat`} alt="WeChat" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
            </div>
            <div className="footer-container footer-container--mobile container">
                <div className="footer__mobile-logo">
                    <FooterLogo />
                    <p className="footer__copyright pt-0">
                        <span>FindDoc 不會提供任何形式的醫療建議、診斷或診治。</span>
                        <br></br>
                        <span>版權所有 © { new Date().getFullYear() } FindDoc</span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
